import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import { makeStyles } from '@material-ui/core';

import { Box, MUIModal } from 'Components/Base';

const dialogStyles = ({ paper, container }) =>
  makeStyles({
    root: ({ transBlack }) => ({
      backgroundColor: 'transparent',
      '& .MuiBackdrop-root': {
        backgroundColor: `${transBlack}`,
      },
    }),
    paper: {
      backgroundColor: 'transparent',
      borderRadius: '16px',
      overflow: 'hidden',
      boxShadow: 'none',
      maxWidth: '480px',
      width: '100%',

      '&::-webkit-scrollbar': {
        display: 'none',
      },

      '& .MuiDialogContent-root': {
        overflowY: 'visible',
      },
      ...paper,
    },
    container: { ...container },
  });

const Modal = ({
  disableTopOffset,
  header,
  contents,
  footer,
  footerProps,
  contentWrapperProps,
  contentProps,
  muiProps,
}) => {
  const { colors } = useTheme();
  const {
    isActive,
    toggleComponent,
    onOpen,
    onClose,
    muiStyles,
    modalPaperStyle,
    innerProps,
    styleModalContentProps,
    modalContainerStyle,
    ...restMuiProps
  } = muiProps;
  const dialogClasses = dialogStyles({ paper: modalPaperStyle, container: modalContainerStyle })({
    transBlack: colors.blacks[10],
    primary: colors.primary,
  });

  return (
    <MUIModal
      isOpen={isActive}
      toggleComponent={toggleComponent}
      onOpenModal={onOpen}
      onCloseModal={onClose}
      closeIcon={false}
      modalStyle={{
        padding: '0px',
      }}
      classes={{ ...dialogClasses, ...muiStyles }}
      disableBackdropClick
      disableEscapeKeyDown
      innerProps={innerProps}
      styleModalContentProps={styleModalContentProps}
      {...restMuiProps}
    >
      {!disableTopOffset && <Box height={10} bg={colors.primary} />}
      <Box px={{ _: 4, md: 7 }} py={7} {...contentWrapperProps}>
        {header && <Box>{header}</Box>}
        {contents && <Box {...contentProps}>{contents}</Box>}
        {footer && <Box {...footerProps}>{footer}</Box>}
      </Box>
    </MUIModal>
  );
};

Modal.propTypes = {
  disableTopOffset: PropTypes.bool,
  muiProps: PropTypes.shape({
    toggleComponent: PropTypes.element,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    isActive: PropTypes.bool,
    muiStyles: PropTypes.object,
    modalPaperStyle: PropTypes.object,
    innerProps: PropTypes.object,
    styleModalContentProps: PropTypes.object,
    modalContainerStyle: PropTypes.object,
  }),
  header: PropTypes.element,
  contents: PropTypes.element,
  contentWrapperProps: PropTypes.object,
  contentProps: PropTypes.object,
  footer: PropTypes.element,
  footerProps: PropTypes.object,
};

Modal.defaultProps = {
  disableTopOffset: false,
};

export default Modal;
